import { Link } from "@tanstack/react-router";
import { PERSON_ID } from "@/content/author";
import { createFileRoute } from "@tanstack/react-router";
import { talks, formatTalkDate } from "@/lib/talks";
import { YouTubeFacade } from "@/components/YouTubeFacade";
import { PageIntro, PageSection } from "@/components/site/page";
import { AUTHOR_URL } from "@/content/author";

const URL = "https://akillisurdurulebilirlik.com/konusmalar";
const TITLE = "Konuşmalar — Arda Öztaşkın";
const DESC = `Arda Öztaşkın'ın yapay zekâ, sürdürülebilirlik, iklim ve finans üzerine konferans, panel ve söyleşi kayıtları: 2022'den bu yana ${talks.length} konuşma.`;

export const Route = createFileRoute("/konusmalar")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: "Konferans, panel ve söyleşi kayıtları; en yenisi en üstte." },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ItemList",
          itemListOrder: "https://schema.org/ItemListOrderDescending",
          name: "Konuşmalar — Arda Öztaşkın",
          itemListElement: talks.map((t, i) => ({
            "@type": "ListItem",
            position: i + 1,
            item: {
              "@type": "VideoObject",
              name: t.topic,
              description: `${t.topic} — ${t.program}`,
              thumbnailUrl: [`https://i.ytimg.com/vi/${t.id}/maxresdefault.jpg`, `https://i.ytimg.com/vi/${t.id}/hqdefault.jpg`],
              uploadDate: t.date,
              contentUrl: t.url,
              embedUrl: `https://www.youtube.com/embed/${t.id}`,
              inLanguage: "tr",
              publisher: { "@type": "Organization", name: t.program },
              author: { "@id": PERSON_ID },
            },
          })),
        }),
      },
    ],
  }),
  component: KonusmalarPage,
});

function KonusmalarPage() {
  const [featured, ...rest] = talks;
  const years = [...new Set(rest.map((t) => t.date.slice(0, 4)))];

  return (
    <>
      <PageIntro
        crumbs={[{ label: "Yazar", to: "/yazar" }, { label: "Konuşmalar" }]}
        kicker="Arşiv"
        title="Konuşmalar"
        lede={`Konferans, panel ve söyleşi kayıtları. ${talks.length} kayıt; en yenisi en üstte. Kayıtlar Türkçe.`}
      />

      {featured && (
        <PageSection title="En son konuşma">
          <div className="max-w-4xl">
            <YouTubeFacade videoId={featured.id} title={featured.topic} watchUrl={featured.url} className="mb-4" />
            <p className="text-[11px] uppercase tracking-[0.2em] text-ink/70">{formatTalkDate(featured.date)} · {featured.program}</p>
            <Link to="/konusmalar/$id" params={{ id: featured.id }} className="mt-1 block text-balance font-serif text-2xl hover:text-clay md:text-3xl">
              {featured.topic}
            </Link>
          </div>
        </PageSection>
      )}

      {years.map((y) => (
        <PageSection key={y} title={y}>
          <ul className="max-w-4xl">
            {rest
              .filter((t) => t.date.startsWith(y))
              .map((t) => (
                <li key={t.id} className="border-t border-ink/10">
                  <Link to="/konusmalar/$id" params={{ id: t.id }} className="group grid grid-cols-[112px_minmax(0,1fr)] items-start gap-4 py-4 sm:grid-cols-[176px_minmax(0,1fr)] sm:gap-6">
                    <img src={`https://i.ytimg.com/vi/${t.id}/hqdefault.jpg`} alt="" width={176} height={99} loading="lazy" className="aspect-video w-full object-cover" />
                    <span className="min-w-0">
                      <span className="block text-[12px] text-ink/65">{formatTalkDate(t.date)}</span>
                      <span className="mt-0.5 block font-serif text-[17px] leading-snug group-hover:text-clay sm:text-[20px]">{t.topic}</span>
                      <span className="mt-0.5 block text-[13px] text-ink/70">{t.program}</span>
                      <span className="mt-1 hidden text-[12px] text-theme-tech sm:block">Konuşmayı aç →</span>
                    </span>
                  </Link>
                </li>
              ))}
          </ul>
        </PageSection>
      ))}
    </>
  );
}
